module.exports = __webpack_public_path__ + "img/artillery-wagon-base-shadow-5.fbf41f78.png";